export function ConvertToAccess(data, op = true) {
    if(data) {
        try {
            const access = op ? JSON.parse(atob(data)) : data;
            let obj = [];
            access.map((items, index) => {
                if(index === 0) {
                    obj.push({
                        id: '1',
                        name: getName(items[0]),
                        details: [
                            {
                                id: '101',
                                access: items[1], // 0 [0][0]
                                title: 'پیمایش در تاریخ',
                            },{
                                id: '102',
                                access: items[2], // 1 [0][1]
                                title: 'نمایش نوبت‌ها',
                            },{
                                id: '104',
                                access: items[4], //! [0][3]
                                title: 'نمایش لاگ‌ها',
                            },{
                                id: '103',
                                access: items[3], // 2 [0][2]
                                title: 'تعریف نوبت جدید',
                            },
                        ]
                    })
                } else if(index === 1) {
                    obj.push({
                        id: '2',
                        name: getName(items[0]),
                        details: [
                            {
                                id: '201',
                                access: items[1], // 3 [1][0]
                                title: 'امکان تغییر وضعیت',
                            },{
                                id: '202',
                                access: items[2], // 4 [1][1]
                                title: 'اضافه/حذف تراکنش مالی',
                            },{
                                id: '203',
                                access: items[3], // 5 [1][2]
                                title: 'مشاهده وضعیت‌ها و تراکنش‌ها',
                            },{
                                id: '204',
                                access: items[4], // 6 [1][3]
                                title: 'ویرایش نوع نوبت',
                            },{
                                id: '205',
                                access: items[5], // 7 [1][4]
                                title: 'حذف نوبت',
                            },{
                                id: '206',
                                access: items[6], // 8 [1][5]
                                title: 'ویرایش وضعیت',
                            },{
                                id: '207',
                                access: items[7], // 9 [1][6]
                                title: 'حذف وضعیت',
                            },
                        ]
                    })
                } else if(index === 2) {
                    obj.push({
                        id: '3',
                        name: getName(items[0]),
                        details: [
                            {
                                id: '301',
                                access: items[1], // 10 [2][0]
                                title: 'مشاهده بیماران',
                            },{
                                id: '302',
                                access: items[2], // 11 [2][1]
                                title: 'مشاهده نوبت بیماران',
                            },{
                                id: '303',
                                access: items[3], // 12 [2][2]
                                title: 'امکان ویرایش بیمار',
                            },{
                                id: '304',
                                access: items[4], // 13 [2][3]
                                title: 'امکان حذف بیمار',
                            },{
                                id: '305',
                                access: items[5], // 14 [2][4]
                                title: 'افزودن بیمار جدید',
                            },
                        ]
                    })
                } else if(index === 3) {
                    obj.push({
                        id: '4',
                        name: getName(items[0]),
                        details: [
                            {
                                id: '401',
                                access: items[1], // 15 [3][0]
                                title: 'مشاهده کاربران',
                            },{
                                id: '402',
                                access: items[2], // 16 [3][1]
                                title: 'امکان ویرایش مشخصات کاربر',
                            },{
                                id: '403',
                                access: items[3], // 17 [3][2]
                                title: 'امکان ویرایش دسترسی کاربر',
                            },{
                                id: '404',
                                access: items[4], // 18 [3][3]
                                title: 'امکان ویرایش اطلاعات ورود کاربر',
                            },{
                                id: '405',
                                access: items[5], // 19 [3][4]
                                title: 'امکان حذف کاربر',
                            },{
                                id: '406',
                                access: items[6], // 20 [3][5]
                                title: 'افزودن کاربر جدید',
                            },
                        ]
                    })
                } else if(index === 4) {
                    obj.push({
                        id: '5',
                        name: getName(items[0]),
                        details: [
                            {
                                id: '501',
                                access: items[1], // 21 [4][0]
                                title: 'مشاهده تنظیمات',
                            },{
                                id: '502',
                                access: items[2], // 22 [4][1]
                                title: 'زمان‌ها',
                            },{
                                id: '506',
                                access: items[6], //! [4][5]
                                title: 'پیام‌رسان',
                            },{
                                id: '507',
                                access: items[7], //! [4][6]
                                title: 'کارت‌خوان',
                            },{
                                id: '503',
                                access: items[3], // 23 [4][2]
                                title: 'پزشکان',
                            },{
                                id: '504',
                                access: items[4], // 24 [4][3]
                                title: 'نوع‌ها',
                            },{
                                id: '505',
                                access: items[5], // 25 [4][4]
                                title: 'وضعیت‌ها',
                            },
                        ]
                    })
                }
            })
            return obj;
        } catch {
            return false;
        }
    } else {
        return false;
    }
}

export function ConvertToArray(data) {
    if(data) {
        try {
            let obj = [ [93537], [31637], [78339], [81232], [65541] ];
            data.map((items, index) => {
                items.details.sort((a,b) => +a.id - +b.id).map(row => {
                    obj[index].push(row.access);
                })
            })
            return btoa(JSON.stringify(obj))
        } catch {
            return null;
        }
    } else {
        return null;
    }
}

export function ConvertToAccessInternal(data, op = true) {
    if(data) {
        try {
            const access = op ? JSON.parse(atob(data)) : data;
            let obj = [];
            access.map(items => {
                let inner = [];
                items.map((row, id) => {
                    if(id !== 0) {
                        inner.push(row);
                    }
                })
                obj.push(inner);
            })
            return obj;
        } catch (err) {
            console.log(err);
            return false;
        }
    } else {
        return false;
    }
}

function getName(id) {
    switch(id) {
        case 93537: return 'داشبورد';
        case 31637: return 'نوبت ها';
        case 78339: return 'بیماران';
        case 81232: return 'کاربران';
        case 65541: return 'تنظیمات';
        default : return 'تعیین نشده';
    }
}

